import { listIdForSearch } from "../helper";

export const teamsListActions = {

  FETCH_TEAMS_FAILED: 'FETCH_TEAMS_FAILED',
  FETCH_TEAMS_SUCCESS: 'FETCH_TEAMS_SUCCESS',
  FETCH_TEAMS_PENDING: 'FETCH_TEAMS_PENDING',
  LOAD_TEAMS: 'LOAD_TEAMS',
  SEARCH_TEAMS: 'SEARCH_TEAMS',


  fetchTeamsFailed: (error, teamsListId) => ({
    type: teamsListActions.FETCH_TEAMS_FAILED,
    payload: {
      error,
      teamsListId
    }
  }),

  fetchTeamsSuccess: (teamsListId, data) => ({
    type: teamsListActions.FETCH_TEAMS_SUCCESS,
    payload: {
      data,
      teamsListId
    }
  }),

  fetchTeamsPending: teamsListId => ({
    type: teamsListActions.FETCH_TEAMS_PENDING,
    payload: {
      teamsListId
    }
  }),

  loadTeams: (grupo) => ({
    type: teamsListActions.LOAD_TEAMS,
    payload: {
      teamsListId: grupo
    }
  }),

  searchTeams: (filters) => ({
      type: teamsListActions.SEARCH_TEAMS,
      payload: {
        teamsListId: listIdForSearch(filters),
        filters
      }
  }),
};


export const teamsListRequestActions = {
  failed: teamsListActions.fetchTeamsFailed,
  success: teamsListActions.fetchTeamsSuccess,
  pending: teamsListActions.fetchTeamsPending
};
